import classNames from 'classnames';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from 'wix-style-react';
import { usePageModeContext } from '../../../providers/PageMode/PageMode.provider';
import { ADVANCED_PLANS_APP_STEPS } from '../../../stores/App.store';
import s from '../BackButton.scss';

export interface BackButtonProps {
  handleOnBackButtonClick(): void;
  currentStep: number;
}

const getStepTranslated = (t, currentStep) => {
  return currentStep ? t(ADVANCED_PLANS_APP_STEPS[currentStep - 1]) : '';
};

export const BackButton: React.FunctionComponent<BackButtonProps> = ({
  handleOnBackButtonClick,
  currentStep,
}) => {
  const { t } = useTranslation();
  const { theme } = usePageModeContext();
  return (
    <div
      className={classNames(
        s.backButton,
        {
          [s.hidden]: currentStep <= 0,
        },
        theme,
      )}
    >
      <button
        data-hook='back-button'
        disabled={currentStep <= 0}
        onClick={handleOnBackButtonClick}
      >
        <div className={classNames(s.buttonIcon, theme)} />
        <div className={s.stepTitle}>
          <Text weight='bold' size='small'>
            {getStepTranslated(t, currentStep)}
          </Text>
        </div>
      </button>
    </div>
  );
};
